(function () {
    'use strict';

    angular.module('swif.openbase')
        .service('swifOpenbaseLanguageService', swifOpenbaseLanguageService);

    function swifOpenbaseLanguageService(dataService, gettextCatalog, amMoment, tmhDynamicLocale, settingsService) {
        'ngInject';

        var service = {};
        service.getLanguages = function () {
            var filter = {};
            filter.fields = ['code', 'iso_code', 'name'];
            return dataService.searchRead('res_lang', filter);
        };

        service.findLang = function(languages, lng, key) {
            return languages.find( lang => lang[key] === lng );
        };

        // isoCode (two chars string) is used to set language
        // It must match translation files e.g 'fr.po'
        service.getIsoCode = function(userLang) {
            const defaultAppLang = settingsService.app.defaultValues ? settingsService.app.defaultValues.user.context_lang : 'fr';
            return userLang ? userLang.split('_')[0] : defaultAppLang.split('_')[0];
        };

        service.applyLang = function(userLang) {
            var lang = service.getIsoCode(userLang);

            gettextCatalog.setCurrentLanguage(lang);
            amMoment.changeLocale(lang);
            tmhDynamicLocale.set(lang);
            window.localStorage.setItem('language', lang);
        };
        return service;
    }
})();
